import { gql } from "@apollo/client";

const UPDATE_TASK = gql`
  mutation updateCampaignTask($id: ID!, $description: String!, $dueDate: ISO8601Date) {
    updateCampaignTask(id: $id, description: $description, dueDate: $dueDate)
  }
`;

export default UPDATE_TASK;
